import { render, staticRenderFns } from "./InternalFinishing.vue?vue&type=template&id=a979e87c&lang=pug&"
import script from "./InternalFinishing.vue?vue&type=script&lang=js&"
export * from "./InternalFinishing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports